// @ts-nocheck
import { useEffect, useLayoutEffect, useState } from "react";
// because of ssr isMobile can't access navigator or window before the first render so we need to set as null as default to avoid layout shift
const useIsMobile = ({ width = 768 } = {}) => {
    const isWindowUndefined = typeof window === "undefined";
    const [isMobile, setIsMobile] = useState<boolean | null>(null);
    useLayoutEffect(() => {
        if (isWindowUndefined) {
            return;
        }
        setIsMobile(window.innerWidth <= width);
    }, [width, isWindowUndefined]);
    useEffect(() => {
        if (isWindowUndefined) {
            return;
        }
        const mediaQuery = window.matchMedia(`(max-width: ${width}px)`);
        const handleChange = (e: MediaQueryListEvent | MediaQueryList) => {
            setIsMobile(e.matches);
        };

        handleChange(mediaQuery);

        mediaQuery.addEventListener("change", handleChange);

        return () => {
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, [width, isWindowUndefined]);

    return isMobile;
};

export default useIsMobile;
